import { render, staticRenderFns } from "./task-square.vue?vue&type=template&id=fd58e036&"
import script from "./task-square.vue?vue&type=script&lang=js&"
export * from "./task-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd58e036')) {
      api.createRecord('fd58e036', component.options)
    } else {
      api.reload('fd58e036', component.options)
    }
    module.hot.accept("./task-square.vue?vue&type=template&id=fd58e036&", function () {
      api.rerender('fd58e036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/task-square.vue"
export default component.exports